/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkReservation } from '../models/work-reservation';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateReservationDto } from '../models/work-update-reservation-dto';
import { WorkVerifyReservationManuallyDto } from '../models/work-verify-reservation-manually-dto';

@Injectable({ providedIn: 'root' })
export class WorkReservationsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reservationsV2ControllerFindAllPaginated()` */
  static readonly ReservationsV2ControllerFindAllPaginatedPath = '/v2/reservations';

  /**
   * Required permissions: reservations:read, reservations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationsV2ControllerFindAllPaginated$Response(
    params?: {
      onlyMetas?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by otpVerified query param.
     *           <p>
     *              <b>Format: </b> filter.otpVerified={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.otpVerified=$not:$like:John Doe&filter.otpVerified=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.otpVerified'?: Array<string>;

    /**
     * Filter by contactId query param.
     *           <p>
     *              <b>Format: </b> filter.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contactId=$not:$like:John Doe&filter.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$in</li></ul>
     */
      'filter.contactId'?: Array<string>;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$in</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by reservationteamId query param.
     *           <p>
     *              <b>Format: </b> filter.reservationteamId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.reservationteamId=$not:$like:John Doe&filter.reservationteamId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$in</li></ul>
     */
      'filter.reservationteamId'?: Array<string>;

    /**
     * Filter by reservationtypes query param.
     *           <p>
     *              <b>Format: </b> filter.reservationtypes={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.reservationtypes=$not:$like:John Doe&filter.reservationtypes=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.reservationtypes'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> start:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>businessunitId</li>
     * <li>contactId</li>
     * <li>start</li>
     * <li>lastName</li>
     * <li>city</li>
     * <li>zipcode</li>
     * <li>objectZip</li>
     * <li>objectCity</li>
     * <li>objectStreet</li>
     * <li>created</li>
     * <li>reservationteamId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'businessunitId:ASC' | 'businessunitId:DESC' | 'contactId:ASC' | 'contactId:DESC' | 'start:ASC' | 'start:DESC' | 'lastName:ASC' | 'lastName:DESC' | 'city:ASC' | 'city:DESC' | 'zipcode:ASC' | 'zipcode:DESC' | 'objectZip:ASC' | 'objectZip:DESC' | 'objectCity:ASC' | 'objectCity:DESC' | 'objectStreet:ASC' | 'objectStreet:DESC' | 'created:ASC' | 'created:DESC' | 'reservationteamId:ASC' | 'reservationteamId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> lastName,city,zipcode,objectZip,objectCity
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>lastName</li>
     * <li>city</li>
     * <li>zipcode</li>
     * <li>objectZip</li>
     * <li>objectCity</li>
     * <li>objectStreet</li>
     * <li>notes</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkReservation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'otpVerified'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'reservationteamId'?: (string | Array<string>);
'reservationtypes'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsV2Service.ReservationsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('onlyMetas', params.onlyMetas, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.otpVerified', params['filter.otpVerified'], {});
      rb.query('filter.contactId', params['filter.contactId'], {});
      rb.query('filter.businessunitId', params['filter.businessunitId'], {});
      rb.query('filter.reservationteamId', params['filter.reservationteamId'], {});
      rb.query('filter.reservationtypes', params['filter.reservationtypes'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkReservation>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'otpVerified'?: (string | Array<string>);
        'contactId'?: (string | Array<string>);
        'businessunitId'?: (string | Array<string>);
        'reservationteamId'?: (string | Array<string>);
        'reservationtypes'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: reservations:read, reservations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationsV2ControllerFindAllPaginated(
    params?: {
      onlyMetas?: boolean;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by otpVerified query param.
     *           <p>
     *              <b>Format: </b> filter.otpVerified={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.otpVerified=$not:$like:John Doe&filter.otpVerified=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.otpVerified'?: Array<string>;

    /**
     * Filter by contactId query param.
     *           <p>
     *              <b>Format: </b> filter.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contactId=$not:$like:John Doe&filter.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$in</li></ul>
     */
      'filter.contactId'?: Array<string>;

    /**
     * Filter by businessunitId query param.
     *           <p>
     *              <b>Format: </b> filter.businessunitId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.businessunitId=$not:$like:John Doe&filter.businessunitId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$in</li></ul>
     */
      'filter.businessunitId'?: Array<string>;

    /**
     * Filter by reservationteamId query param.
     *           <p>
     *              <b>Format: </b> filter.reservationteamId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.reservationteamId=$not:$like:John Doe&filter.reservationteamId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$in</li></ul>
     */
      'filter.reservationteamId'?: Array<string>;

    /**
     * Filter by reservationtypes query param.
     *           <p>
     *              <b>Format: </b> filter.reservationtypes={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.reservationtypes=$not:$like:John Doe&filter.reservationtypes=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.reservationtypes'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> start:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>businessunitId</li>
     * <li>contactId</li>
     * <li>start</li>
     * <li>lastName</li>
     * <li>city</li>
     * <li>zipcode</li>
     * <li>objectZip</li>
     * <li>objectCity</li>
     * <li>objectStreet</li>
     * <li>created</li>
     * <li>reservationteamId</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'businessunitId:ASC' | 'businessunitId:DESC' | 'contactId:ASC' | 'contactId:DESC' | 'start:ASC' | 'start:DESC' | 'lastName:ASC' | 'lastName:DESC' | 'city:ASC' | 'city:DESC' | 'zipcode:ASC' | 'zipcode:DESC' | 'objectZip:ASC' | 'objectZip:DESC' | 'objectCity:ASC' | 'objectCity:DESC' | 'objectStreet:ASC' | 'objectStreet:DESC' | 'created:ASC' | 'created:DESC' | 'reservationteamId:ASC' | 'reservationteamId:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> lastName,city,zipcode,objectZip,objectCity
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>lastName</li>
     * <li>city</li>
     * <li>zipcode</li>
     * <li>objectZip</li>
     * <li>objectCity</li>
     * <li>objectStreet</li>
     * <li>notes</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkReservation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'otpVerified'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'reservationteamId'?: (string | Array<string>);
'reservationtypes'?: (string | Array<string>);
};
};
}> {
    return this.reservationsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkReservation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'otpVerified'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'reservationteamId'?: (string | Array<string>);
'reservationtypes'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkReservation>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'otpVerified'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'businessunitId'?: (string | Array<string>);
'reservationteamId'?: (string | Array<string>);
'reservationtypes'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `reservationsV2ControllerFindOneById()` */
  static readonly ReservationsV2ControllerFindOneByIdPath = '/v2/reservations/{id}';

  /**
   * Required permissions: reservations:read, reservations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsV2Service.ReservationsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservation>;
      })
    );
  }

  /**
   * Required permissions: reservations:read, reservations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkReservation> {
    return this.reservationsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservation>): WorkReservation => r.body)
    );
  }

  /** Path part for operation `reservationsV2ControllerDelete()` */
  static readonly ReservationsV2ControllerDeletePath = '/v2/reservations/{id}';

  /**
   * Required permissions: reservations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsV2Service.ReservationsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: reservations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.reservationsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `reservationsV2ControllerUpdate()` */
  static readonly ReservationsV2ControllerUpdatePath = '/v2/reservations/{id}';

  /**
   * Required permissions: reservations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateReservationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsV2Service.ReservationsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservation>;
      })
    );
  }

  /**
   * Required permissions: reservations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateReservationDto
    },
    context?: HttpContext
  ): Observable<WorkReservation> {
    return this.reservationsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservation>): WorkReservation => r.body)
    );
  }

  /** Path part for operation `reservationsV2ControllerVerifyManually()` */
  static readonly ReservationsV2ControllerVerifyManuallyPath = '/v2/reservations/{id}/verify-manually';

  /**
   * Required permissions: reservations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV2ControllerVerifyManually()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV2ControllerVerifyManually$Response(
    params: {
      id: number;
      body: WorkVerifyReservationManuallyDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsV2Service.ReservationsV2ControllerVerifyManuallyPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservation>;
      })
    );
  }

  /**
   * Required permissions: reservations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV2ControllerVerifyManually$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV2ControllerVerifyManually(
    params: {
      id: number;
      body: WorkVerifyReservationManuallyDto
    },
    context?: HttpContext
  ): Observable<WorkReservation> {
    return this.reservationsV2ControllerVerifyManually$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservation>): WorkReservation => r.body)
    );
  }

}
